import { getRequest, postRequest } from "../../shared/api/axiosHandler";
import { clearCouponCache } from "../coupons/api";

export const saveGusetCustomerOrder = async (order) => {
  try {
    return await postRequest('/public/orders', order);
  } catch (error) {
    throw error;
  }
}

export const handleBuyNow = async (product) => { // Add quantity: 1
  sessionStorage.setItem("buyNow", JSON.stringify(product));
  
}

export const getBuyNow = () => {
  return JSON.parse(sessionStorage.getItem('buyNow'));
}

export const clearBuyNow = () => {
  sessionStorage.removeItem('buyNow');
}

export const getBuyNowTotal = () => {
  const buyNowProduct = JSON.parse(sessionStorage.getItem("buyNow"));
  if (!buyNowProduct) return 0; 

  const quantity = buyNowProduct.quantity || 1;
  let effectiveUnitPrice = 0;
  const config = buyNowProduct.configuration;
  const discountActive =
    config &&
    config?.Sale?.collectionConfiguration &&
    config?.Sale?.collectionConfiguration?.discount &&
    config.Sale?.configStatus === "active";

  if (discountActive) {
    const discount = config.Sale.collectionConfiguration.discount;
    // If a salePrice exists, apply the discount on it; otherwise, use the regularPrice.
    if (buyNowProduct.salePrice) {
      effectiveUnitPrice = buyNowProduct.salePrice * (1 - discount / 100);
    } else {
      effectiveUnitPrice = buyNowProduct.regularPrice * (1 - discount / 100);
    }
  } else {
    // If no active discount, use salePrice if available; otherwise, use regularPrice.
    effectiveUnitPrice = buyNowProduct.salePrice || buyNowProduct.regularPrice || 0;
  }

  return effectiveUnitPrice * quantity;
};

export const getDeliveryFeeMatrix = async () => {
  try {
    return await getRequest(`/public/products/delivery-fee-matrix`);
  } catch (error) {
    throw error;
  }
}

export const createOrder = async (order) => {
    try {
        const response = await postRequest("/api/v1/orders", order, true);
        clearCouponCache();
        return response;
    } catch (error) {
        throw error;
    }
};

export const getKokoTaxRate = async () => {
  const response = await getRequest(`/api/vm/user/current-rate`);
  return Number(response["koko-tax"]);
};
